import React from 'react';

// Official Ministry of Education emblem, converted to SVG from the ministry's
// own vector artwork (public/moe-emblem.svg) — geometry and gradient unaltered.
const MinistryEmblem = ({ height = 40, alt = 'Ministry of Education', className }) => (
  <img
    src={`${process.env.PUBLIC_URL}/moe-emblem.svg`}
    height={height}
    style={{ height, width: 'auto' }}
    alt={alt}
    className={className}
    draggable="false"
  />
);

export default MinistryEmblem;
